const baseUrl = import.meta.env.VITE_API_URL
// const baseUrl = "https://api.creditbricks.in/api"
// const baseUrl = "http://18.60.70.52:3300"
export default baseUrl